<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0ZM6.075 5.85a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm4.95.9a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0ZM9 15a4.8 4.8 0 0 0 4.8-4.8H4.2A4.8 4.8 0 0 0 9 15Z"
          fill="currentColor"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'SmileyHappy',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>